'use client';

import React, { ImgHTMLAttributes, useState } from 'react';

interface ImageWithFallbackProps extends ImgHTMLAttributes<HTMLImageElement> {
	fallbackSrc?: string;
	alt: string;
}

const ImageWithFallback = (props: ImageWithFallbackProps) => {
	const { src, fallbackSrc = '/assets/images/placeholder.png', ...rest } = props;
	const [imgSrc, setImgSrc] = useState(src || fallbackSrc);

	return <img src={imgSrc} onError={() => setImgSrc(fallbackSrc)} {...rest} alt={props.alt || ''} />;
};

export default React.memo(ImageWithFallback);
